import { AxiosResponse } from "axios";
import HttpService from "./interface/HttpService";
import { ElectricDistributionCompany } from "../model/electricDistributionCompany";

class ElectricDistributionCompanyService {
    private instance: HttpService;
    private controllerName: string = 'electricity-distribution-company';

    constructor() {
        this.instance = new HttpService(this.controllerName);
    }

    public getAll(): Promise<AxiosResponse<ElectricDistributionCompany[]>> {
        return this.instance.get();
    }
}

export default ElectricDistributionCompanyService;